import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const listTheme = {
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 32
      }
    }
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: tokens.colorSecondaryContainer,
          color: tokens.colorOnSecondaryContainer,
          width: '100%',
          height: '100%',
          position: 'relative'
        }
      }
    }
  }
} satisfies Components;
